const LAST_VISITED_PACKAGE_PREFIX = "lastVisitedPackage_";

export class PackagesLocalHistoryService {
    static $inject = ["sessionService"];

    constructor(sessionService) {
        this.sessionService = sessionService;
    }

    setLastFocusedPackage(userId,projectId,packageId){
        this.sessionService.set(LAST_VISITED_PACKAGE_PREFIX + `${userId}_${projectId}`, packageId);
    }

    getLastFocusedPackage(userId,projectId){
       return this.sessionService.get(LAST_VISITED_PACKAGE_PREFIX + `${userId}_${projectId}`);
    }

    removePackageSelectionHistory(userId,projectId){
        this.sessionService.remove(LAST_VISITED_PACKAGE_PREFIX + `${userId}_${projectId}`);
    }
}



// WEBPACK FOOTER //
// ./src/services/history/packagesLocalHistoryService.js